import { mergeDicts } from "../../../../shared/i18n";
import core from "./core";
import panels from "./panels";
import plan from "./plan";
import shell from "./shell";

/** Все словари интерфейса. Каждый файл — своя часть приложения. */
export const DICT = mergeDicts(core, shell, plan, panels);
